import { usePage } from "@inertiajs/react";

export default function AppLogo() {
    const { name } = usePage().props;

    return (
        <>
            <div className="flex size-8 items-center justify-center">
                <img src="/favicon.svg" alt="" className="size-6" />
            </div>
            <div className="grid flex-1 text-left text-sm group-data-[collapsible=icon]:hidden">
                <span className="mb-0.5 truncate font-heading leading-tight font-bold">
                    {name}
                </span>
            </div>
        </>
    );
}
